import {InjectionToken} from '@angular/core';

export class AppConfig {
  public websocketBaseDomain: string;
  public websocketProtocol: string;
  public websocketHttpProtocol: string;
  public base: string;
  public environment: 'development' | 'staging' | 'production';

  constructor() {
  }

  get wsConfig(): { websocketProtocol: string, websocketHttpProtocol: string } {
    return {
      websocketProtocol: this.websocketProtocol ?? 'wss',
      websocketHttpProtocol: this.websocketHttpProtocol ?? 'https',
    }
  }

  get angularEndpoint(): string {
    return `${this.base}/api/ang`;
  }

  get abpEndpoint(): string {
    return `${this.base}/api/app`;
  }

  get baseApiEndpoint(): string {
    return `${this.base}/api`;
  }
}

export let APP_CONFIG = new InjectionToken<AppConfig>('APP_CONFIG')
